export const STAFF = 'staff'
export const CUSTOMER = 'customer'
export const GUEST = 'guest'
